import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../stores/root';
import OrdersList from '../../components/orders/general/list';
import GoodsList from '../../components/goods/general/list';
import { faHome } from '@fortawesome/pro-light-svg-icons';

interface IGoodsListPageProps {
}

const GoodsListPage: React.FC<IGoodsListPageProps> = (props: IGoodsListPageProps) => {
    const {topbar} = useStore();

    useEffect(() => {
        topbar.show("Goods", [
            {key: "home", icon: faHome, href: "/"},
            {key: "goods", text: 'Goods'}
        ])
    }, []);

    return <Stack>
        <GoodsList />
    </Stack>;
};

export default GoodsListPage;
